function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function () { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function (t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function (t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function (e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function () { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function (e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function (t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function (t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function (e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import get from "lodash/get";
import has from "lodash/has";
import merge from "lodash/merge";
import { Locales } from "./Locales";
import { Pluralization } from "./Pluralization";
import { MissingTranslation } from "./MissingTranslation";
import { camelCaseKeys, createTranslationOptions, formatNumber, getFullScope, inferType, interpolate, isSet, lookup, numberToDelimited, numberToHuman, numberToHumanSize, parseDate, pluralize, strftime, timeAgoInWords } from "./helpers";
const DEFAULT_I18N_OPTIONS = {
  defaultLocale: "en",
  availableLocales: ["en"],
  locale: "en",
  defaultSeparator: ".",
  placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
  enableFallback: false,
  missingBehavior: "message",
  missingTranslationPrefix: "",
  missingPlaceholder: (_i18n, placeholder) => `[missing "${placeholder}" value]`,
  nullPlaceholder: (i18n, placeholder, message, options) => i18n.missingPlaceholder(i18n, placeholder, message, options),
  transformKey: key => key
};
export class I18n {
  constructor() {
    let translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this._locale = DEFAULT_I18N_OPTIONS.locale;
    this._defaultLocale = DEFAULT_I18N_OPTIONS.defaultLocale;
    this._version = 0;
    this.onChangeHandlers = [];
    this.translations = {};
    this.availableLocales = [];
    this.t = this.translate;
    this.p = this.pluralize;
    this.l = this.localize;
    this.distanceOfTimeInWords = this.timeAgoInWords;
    const _Object$assign = Object.assign(Object.assign({}, DEFAULT_I18N_OPTIONS), options),
      locale = _Object$assign.locale,
      enableFallback = _Object$assign.enableFallback,
      missingBehavior = _Object$assign.missingBehavior,
      missingTranslationPrefix = _Object$assign.missingTranslationPrefix,
      missingPlaceholder = _Object$assign.missingPlaceholder,
      nullPlaceholder = _Object$assign.nullPlaceholder,
      defaultLocale = _Object$assign.defaultLocale,
      defaultSeparator = _Object$assign.defaultSeparator,
      placeholder = _Object$assign.placeholder,
      transformKey = _Object$assign.transformKey;
    this.locale = locale;
    this.defaultLocale = defaultLocale;
    this.defaultSeparator = defaultSeparator;
    this.enableFallback = enableFallback;
    this.locale = locale;
    this.missingBehavior = missingBehavior;
    this.missingTranslationPrefix = missingTranslationPrefix;
    this.missingPlaceholder = missingPlaceholder;
    this.nullPlaceholder = nullPlaceholder;
    this.placeholder = placeholder;
    this.pluralization = new Pluralization(this);
    this.locales = new Locales(this);
    this.missingTranslation = new MissingTranslation(this);
    this.transformKey = transformKey;
    this.interpolate = interpolate;
    this.store(translations);
  }
  store(translations) {
    merge(this.translations, translations);
    this.hasChanged();
  }
  get locale() {
    return this._locale || this.defaultLocale || "en";
  }
  set locale(newLocale) {
    if (typeof newLocale !== "string") {
      throw new Error(`Expected newLocale to be a string; got ${inferType(newLocale)}`);
    }
    const changed = this._locale !== newLocale;
    this._locale = newLocale;
    if (changed) {
      this.hasChanged();
    }
  }
  get defaultLocale() {
    return this._defaultLocale || "en";
  }
  set defaultLocale(newLocale) {
    if (typeof newLocale !== "string") {
      throw new Error(`Expected newLocale to be a string; got ${inferType(newLocale)}`);
    }
    const changed = this._defaultLocale !== newLocale;
    this._defaultLocale = newLocale;
    if (changed) {
      this.hasChanged();
    }
  }
  translate(scope, options) {
    options = Object.assign({}, options);
    const translationOptions = createTranslationOptions(this, scope, options);
    let translation;
    const hasFoundTranslation = translationOptions.some(translationOption => {
      if (isSet(translationOption.scope)) {
        translation = lookup(this, translationOption.scope, options);
      } else if (isSet(translationOption.message)) {
        translation = translationOption.message;
      }
      return translation !== undefined && translation !== null;
    });
    if (!hasFoundTranslation) {
      return this.missingTranslation.get(scope, options);
    }
    if (typeof translation === "string") {
      translation = this.interpolate(this, translation, options);
    } else if (typeof translation === "object" && translation && isSet(options.count)) {
      translation = pluralize({
        i18n: this,
        count: options.count || 0,
        scope: translation,
        options,
        baseScope: getFullScope(this, scope, options)
      });
    }
    if (options && translation instanceof Array) {
      translation = translation.map(entry => typeof entry === "string" ? interpolate(this, entry, options) : entry);
    }
    return translation;
  }
  pluralize(count, scope, options) {
    return pluralize({
      i18n: this,
      count,
      scope,
      options: Object.assign({}, options),
      baseScope: getFullScope(this, scope, options !== null && options !== void 0 ? options : {})
    });
  }
  localize(type, value, options) {
    options = Object.assign({}, options);
    if (value === undefined || value === null) {
      return "";
    }
    switch (type) {
      case "currency":
        return this.numberToCurrency(value);
      case "number":
        return formatNumber(value, Object.assign({
          delimiter: ",",
          precision: 3,
          separator: ".",
          significant: false,
          stripInsignificantZeros: false
        }, lookup(this, "number.format")));
      case "percentage":
        return this.numberToPercentage(value);
      default:
        {
          let localizedValue;
          if (type.match(/^(date|time)/)) {
            localizedValue = this.toTime(type, value);
          } else {
            localizedValue = value.toString();
          }
          return interpolate(this, localizedValue, options);
        }
    }
  }
  toTime(scope, input) {
    const date = parseDate(input);
    const format = lookup(this, scope);
    if (date.toString().match(/invalid/i)) {
      return date.toString();
    }
    if (!format) {
      return date.toString();
    }
    return this.strftime(date, format);
  }
  numberToCurrency(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return formatNumber(input, Object.assign(Object.assign(Object.assign({
      delimiter: ",",
      format: "%u%n",
      precision: 2,
      separator: ".",
      significant: false,
      stripInsignificantZeros: false,
      unit: "$"
    }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.currency.format"))), options));
  }
  numberToPercentage(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return formatNumber(input, Object.assign(Object.assign(Object.assign({
      delimiter: "",
      format: "%n%",
      precision: 3,
      stripInsignificantZeros: false,
      separator: ".",
      significant: false
    }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.percentage.format"))), options));
  }
  numberToHumanSize(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return numberToHumanSize(this, input, Object.assign(Object.assign(Object.assign({
      delimiter: "",
      precision: 3,
      significant: true,
      stripInsignificantZeros: true,
      units: {
        billion: "Billion",
        million: "Million",
        quadrillion: "Quadrillion",
        thousand: "Thousand",
        trillion: "Trillion",
        unit: ""
      }
    }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.storage_units"))), options));
  }
  numberToHuman(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return numberToHuman(this, input, Object.assign(Object.assign(Object.assign({
      delimiter: "",
      separator: ".",
      precision: 3,
      significant: true,
      stripInsignificantZeros: true,
      format: "%n %u",
      roundMode: "default",
      units: {
        billion: "Billion",
        million: "Million",
        quadrillion: "Quadrillion",
        thousand: "Thousand",
        trillion: "Trillion",
        unit: ""
      }
    }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.decimal_units"))), options));
  }
  numberToRounded(input, options) {
    return formatNumber(input, Object.assign({
      unit: "",
      precision: 3,
      significant: false,
      separator: ".",
      delimiter: "",
      stripInsignificantZeros: false
    }, options));
  }
  numberToDelimited(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return numberToDelimited(input, Object.assign({
      delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g,
      delimiter: ",",
      separator: "."
    }, options));
  }
  withLocale(locale, callback) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var originalLocale;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            originalLocale = this.locale;
            _context.prev = 1;
            this.locale = locale;
            _context.next = 5;
            return callback();
          case 5:
            _context.prev = 5;
            this.locale = originalLocale;
            return _context.finish(5);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[1,, 5, 8]]);
    }));
  }
  strftime(date, format) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return strftime(date, format, Object.assign(Object.assign(Object.assign({}, camelCaseKeys(lookup(this, "date"))), {
      meridian: {
        am: lookup(this, "time.am") || "AM",
        pm: lookup(this, "time.pm") || "PM"
      }
    }), options));
  }
  update(path, override) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      strict: false
    };
    if (options.strict && !has(this.translations, path)) {
      throw new Error(`The path "${path}" is not currently defined`);
    }
    const currentNode = get(this.translations, path);
    const currentType = inferType(currentNode);
    const overrideType = inferType(override);
    if (options.strict && currentType !== overrideType) {
      throw new Error(`The current type for "${path}" is "${currentType}", but you're trying to override it with "${overrideType}"`);
    }
    let newNode;
    if (overrideType === "object") {
      newNode = Object.assign(Object.assign({}, currentNode), override);
    } else {
      newNode = override;
    }
    const components = path.split(this.defaultSeparator);
    const prop = components.pop();
    let buffer = this.translations;
    for (const component of components) {
      if (!buffer[component]) {
        buffer[component] = {};
      }
      buffer = buffer[component];
    }
    buffer[prop] = newNode;
    this.hasChanged();
  }
  toSentence(items) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const _Object$assign2 = Object.assign(Object.assign({
        wordsConnector: ", ",
        twoWordsConnector: " and ",
        lastWordConnector: ", and "
      }, camelCaseKeys(lookup(this, "support.array"))), options),
      wordsConnector = _Object$assign2.wordsConnector,
      twoWordsConnector = _Object$assign2.twoWordsConnector,
      lastWordConnector = _Object$assign2.lastWordConnector;
    const size = items.length;
    switch (size) {
      case 0:
        return "";
      case 1:
        return `${items[0]}`;
      case 2:
        return items.join(twoWordsConnector);
      default:
        return [items.slice(0, size - 1).join(wordsConnector), lastWordConnector, items[size - 1]].join("");
    }
  }
  timeAgoInWords(fromTime, toTime) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return timeAgoInWords(this, fromTime, toTime, options);
  }
  onChange(callback) {
    this.onChangeHandlers.push(callback);
    return () => {
      this.onChangeHandlers.splice(this.onChangeHandlers.indexOf(callback), 1);
    };
  }
  get version() {
    return this._version;
  }
  formatNumber(input) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options = Object.assign(Object.assign({
      delimiter: ",",
      precision: 3,
      separator: ".",
      unit: "",
      format: "%u%n",
      significant: false,
      stripInsignificantZeros: false
    }, camelCaseKeys(this.get("number.format"))), options);
    return formatNumber(input, options);
  }
  get(scope) {
    return lookup(this, scope);
  }
  runCallbacks() {
    this.onChangeHandlers.forEach(callback => callback(this));
  }
  hasChanged() {
    this._version += 1;
    this.runCallbacks();
  }
}